
import React, {useContext, useState} from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  IconButton,
  Fade
} from '@mui/material';
import {HugeiconsIcon} from '@hugeicons/react';
import {Cancel01Icon} from '@hugeicons/core-free-icons';
import {grey} from '@mui/material/colors';
import {Context as AppContext} from "../../../../context/AppContext";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 380,
  width: '90%',
  bgcolor: 'background.paper',
  borderRadius: 3,
  border: '0px solid #000',
  boxShadow: 24,
  px: 3,
  py: 3,
};

export const ContactPhoneNumber = ({phoneNumber, open, handleClose, project}) => {
  const {updateProject} = useContext(AppContext);
  const [name, setName] = useState('');

  const handleSave = async () => {
    try {
      const phonebook = { ...(project.phonebook || {}), [phoneNumber]: name };
      await updateProject({ ...project, phonebook });
      handleClose();
    } catch (error) {
      console.error('Error saving contact:', error);
      // Add toast error notification here
    }
  };

  const handleModalClose = () => {
    setName('');
    handleClose();
  };

  return (
    <Modal
      open={open}
      aria-labelledby="phone-modal-title"
      aria-describedby="phone-modal-description"
      onClose={handleModalClose}
    >
      <Fade in={open} timeout={500}>
        <Box>
          <Box sx={{position: "fixed", top: 10, right: 10}}>
            <IconButton
              size={"small"}
              onClick={handleModalClose}
              color={"#FFF"}
            >
              <HugeiconsIcon icon={Cancel01Icon} color={grey[300]}/>
            </IconButton>
          </Box>

          <Stack direction={"column"} gap={2} sx={style}>
            <Typography id="phone-modal-title" variant="h6" component="h2">
              Contact Information
            </Typography>
            
            <Typography variant="body1" sx={{ wordBreak: 'break-word' }} color="text.secondary">
              <strong>Phone Number:</strong> {phoneNumber}
            </Typography>

            <TextField
              label="Name"
              variant="outlined"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter contact name"
            />

            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button variant="ghost" onClick={handleModalClose}>
                Cancel
              </Button>
              <Button 
                variant="modal" 
                onClick={handleSave}
                disabled={!name.trim()}
              >
                Save
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Fade>
    </Modal>
  )
}
